//404页面
<template>
  <div id="error_view">
    <h3>404 - 页面未找到</h3>
    <p>
        <a href="/">前往首页</a>
    </p>
  </div>
</template>

<script>
export default {
    name: 'error-view',
    data () {
      return {
      }
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/pages/publics/Error.vue